import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "rateview" }
const _hoisted_2 = { class: "leftcontent" }
const _hoisted_3 = { class: "activitybox" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "grow-1" }
const _hoisted_6 = { class: "flex gap" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "blue-text" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "flex-col center" }
const _hoisted_12 = {
  key: 0,
  class: "warning"
}
const _hoisted_13 = { class: "rightcontent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_activity_selector = _resolveComponent("activity-selector")!
  const _component_currency = _resolveComponent("currency")!
  const _component_quantity_ticker = _resolveComponent("quantity-ticker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_activity_selector, { validate: "rate" }),
    _createElementVNode("div", {
      class: _normalizeClass(["content", { package: _ctx.isPackage }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rates, (rate) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "ratebox flex v-center",
              key: rate.EntityHierarchyRateKey,
              onClick: ($event: any) => (_ctx.increment(rate))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(rate.Name), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[2] || (_cache[2] = _createTextVNode("From ", -1)),
                    _createVNode(_component_currency, {
                      amount: rate.Price
                    }, null, 8, ["amount"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    class: "description",
                    innerHTML: rate.Description
                  }, null, 8, _hoisted_10)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_quantity_ticker, {
                  modelValue: rate.Participants,
                  max: rate.MaxParticipants,
                  min: _ctx.min(rate),
                  "onUpdate:modelValue": ($event) => _ctx.updateRate(rate, $event),
                  isRequired: rate.IsRequired,
                  ref_for: true,
                  ref: 'ticker_' + rate.EntityHierarchyRateKey
                }, null, 8, ["modelValue", "max", "min", "onUpdate:modelValue", "isRequired"]),
                (rate.Participants == rate.MaxParticipants)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Maximum of " + _toDisplayString(rate.MaxParticipants), 1))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_4))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          class: _normalizeClass(["bookbutton", { broken: !_ctx.canProceed }]),
          onTouchstart: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)), ["prevent"])),
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)), ["prevent"]))
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("div", { class: "gg-arrow-right-o" }, null, -1),
          _createElementVNode("div", null, "NEXT", -1)
        ]), 34)
      ])
    ], 2)
  ]))
}